import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Inbox, Newspaper, Boxes, Contact, Search, Scale, Users, ScrollText, UserCircle, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/submissions", label: "Submissions", icon: Inbox },
  { to: "/admin/insights", label: "Insights", icon: Newspaper },
  { to: "/admin/brands", label: "Brands", icon: Boxes },
  { to: "/admin/contact", label: "Contact Info", icon: Contact },
  { to: "/admin/seo", label: "SEO", icon: Search },
  { to: "/admin/legal", label: "Legal Pages", icon: Scale },
  { to: "/admin/users", label: "Users", icon: Users },
  { to: "/admin/audit", label: "Audit Log", icon: ScrollText },
  { to: "/admin/account", label: "My Account", icon: UserCircle },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const doLogout = async () => { await logout(); nav("/admin/login"); };

  return (
    <div className="flex min-h-screen bg-slate-50">
      <aside className="hidden w-64 shrink-0 flex-col bg-azeka-navy lg:flex">
        <div className="flex h-16 items-center border-b border-white/10 px-6"><Logo onDark className="h-8 w-auto" /></div>
        <nav className="flex-1 space-y-1 p-3">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${isActive ? "bg-azeka-teal text-white" : "text-slate-300 hover:bg-white/10 hover:text-white"}`}>
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
        </nav>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex h-16 items-center justify-between border-b border-slate-200 bg-white px-6">
          <div className="lg:hidden"><Logo className="h-7 w-auto" /></div>
          <div className="ml-auto flex items-center gap-4">
            <span className="hidden text-sm text-ink-muted sm:inline" data-testid="admin-user-email">{user?.email}</span>
            <button onClick={doLogout} data-testid="admin-logout" className="inline-flex items-center gap-2 rounded-lg border border-slate-300 px-3 py-1.5 text-sm font-medium text-ink-body hover:bg-slate-100">
              <LogOut className="h-4 w-4" /> Sign out
            </button>
          </div>
        </header>
        <main className="flex-1 overflow-y-auto p-6">
          {/* mobile nav */}
          <div className="mb-4 flex gap-2 overflow-x-auto lg:hidden">
            {NAV.map(({ to, label, end }) => (
              <NavLink key={to} to={to} end={end} className={({ isActive }) => `whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium ${isActive ? "bg-azeka-navy text-white" : "bg-white border border-slate-200 text-ink-body"}`}>{label}</NavLink>
            ))}
          </div>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
